import { action, observable } from 'mobx';
import { INotification, INotificationVariant } from './typings';

export default class NotificationsCenterStore {
  @observable barNotifications: INotification[] = [];
  @observable modalNotifications: INotification[] = [];

  @action addNotifications = (
    notifications: INotification[],
    variant: INotificationVariant,
  ) => {
    switch (variant) {
      case 'bar':
        this.setBarNotifications(notifications);
        break;
      case 'modal':
        this.setModalNotifications(notifications);
        break;
      default:
        break;
    }
  }

  @action addNotification = (
    notification: INotification,
    variant: INotificationVariant,
  ) => {
    if (variant === 'bar') {
      const barNotificationExists = this.barNotifications.find(
        (item) => item.id === notification.id,
      );

      if (!barNotificationExists) {
        const notifications = this.barNotifications.map((item) => item);
        notifications.push(notification);
        this.setBarNotifications(notifications);
      }
    } else if (variant === 'modal') {
      const modalNotificationExists = this.modalNotifications.find(
        (item) => item.id === notification.id,
      );

      if (!modalNotificationExists) {
        const notifications = this.modalNotifications.map((item) => item);
        notifications.push(notification);
        this.setModalNotifications(notifications);
      }
    }
  }

  @action updateNotification = (
    notification: INotification,
    variant: INotificationVariant,
  ) => {
    if (variant === 'bar') {
      let existingIndex = -1;
      const notifications = this.barNotifications.map((item, index) => {
        if (item.id === notification.id) {
          existingIndex = index;
          return notification;
        }
        return item;
      });

      if (existingIndex > -1) {
        this.setBarNotifications(notifications);
      }
    } else if (variant === 'modal') {
      let existingIndex = -1;
      const notifications = this.modalNotifications.map((item, index) => {
        if (item.id === notification.id) {
          existingIndex = index;
          return notification;
        }
        return item;
      });

      if (existingIndex > -1) {
        this.setModalNotifications(notifications);
      }
    }
  }

  @action deleteNotification = (
    notification: INotification,
    variant: INotificationVariant,
  ) => {
    if (variant === 'bar') {
      const notifications = this.barNotifications.filter(
        (item) => item.id !== notification.id,
      );

      if (notifications.length < this.barNotifications.length) {
        this.setBarNotifications(notifications);
      }
    } else if (variant === 'modal') {
      const notifications = this.modalNotifications.filter(
        (item) => item.id !== notification.id,
      );

      if (notifications.length < this.modalNotifications.length) {
        this.setModalNotifications(notifications);
      }
    }
  }

  @action setBarNotifications = (barNotifications: INotification[]) => {
    this.barNotifications = barNotifications;
  }

  @action setModalNotifications = (modalNotifications: INotification[]) => {
    this.modalNotifications = modalNotifications;
  }
}
